let GUIDE_NAVIGATION_COMPONENT = document.querySelector('.guide-navigation-component');
if (GUIDE_NAVIGATION_COMPONENT) {
    let guideNavigationSection = document.getElementById('guideNavigationSection');
    let guideContent = document.querySelector(".guide-content");
    let guideNavigationSubSection = document.getElementById('guideNavigationSubsection');
    let subSectionApiEndPoint = guideNavigationSubSection ? guideNavigationSubSection.dataset.subsectionapi : "/";
    let sectionApiEndPoint = guideNavigationSection ? guideNavigationSection.dataset.sectionapi : "/";
    let queryString = window.location.search.toLowerCase();
    let urlParams = new URLSearchParams(queryString);
    let plotcode = urlParams.get('plotcode');
    let sitecode = urlParams.get('sitecode');
    let sectionId = urlParams.get('sectionid');
    let guideid = urlParams.get('guideid');
    let pagemode = urlParams.get('pagemode');
    let query_subSectionId = urlParams.get('subsectionid');

    let showErrorMessageGuides = function (message) {
        document.getElementById("error-msg").classList.remove("hidden");
        document.getElementById("error-msg").innerHTML = `<p>${message}</p>`;
        GUIDE_NAVIGATION_COMPONENT.querySelector('.background-image-container').classList.add("hidden");
        GUIDE_NAVIGATION_COMPONENT.querySelector('.overlay-image-container').classList.add("hidden");
        GUIDE_NAVIGATION_COMPONENT.querySelector('.guide-navigation-backgound').classList.add("hidden");
        document.querySelector('.guide-content-component').classList.add("hidden");
    };

    let getContent = async function (subsectionId, sectionId) {
        const LOADER_WRAPPER = document.createElement('div');
        LOADER_WRAPPER.classList.add('loader-wrapper');
        const LOADER_TITLE = document.createElement('div');
        LOADER_TITLE.classList.add('list-loader');
        LOADER_WRAPPER.appendChild(LOADER_TITLE);
        guideContent.innerHTML = ``;
        guideContent.appendChild(LOADER_WRAPPER);
        let previewMode = "";
        let spCode = "";
        if (pagemode) {
            previewMode = previewMode + `&pageMode=${pagemode}`;
            if (guideid) {
                previewMode = previewMode + `&guideid=${guideid}`;
            }
            if (plotcode) {
                previewMode = previewMode + `&plotCode=${plotcode}`;
            }
            if (sitecode) {
                previewMode = previewMode + `&sitecode=${sitecode}`;
            }
        } else {
            if (plotcode && sitecode) {
                spCode = spCode + `&plotCode=${plotcode}&sitecode=${sitecode}`;
            }
        }
        let response = await fetch(
            `${APIPrefix.get()}/${subSectionApiEndPoint}?sectionID=${sectionId}&subsectionID=${subsectionId}${spCode}${previewMode}`, {
            method: 'GET',
            headers: {
                'Cookie': document.cookie,
            },
        });
        if (response.status == 200) {
            let data = await response.json();
            if (data.status == "failure") {
                return data;
            } else if (data.status === "401") {
                APIUtils.redirectUserToSigninPage();
            }else {
                return data.data;
            }
        } else {
            let msg = document.querySelector('.rest-message--fail').value ? document.querySelector('.rest-message--fail').value : "";
            showErrorMessageGuides(msg);
            return false;
        }
    };

    let getSubsections = async function (sectionId) {
        const LOADER_WRAPPER = document.createElement('div');
        LOADER_WRAPPER.classList.add('loader-wrapper');
        const LOADER_TITLE = document.createElement('div');
        LOADER_TITLE.classList.add('list-loader');
        LOADER_WRAPPER.appendChild(LOADER_TITLE);
        guideContent.innerHTML = ``;
        guideContent.appendChild(LOADER_WRAPPER);
        let previewMode = "";
        let spCode = "";
        if (pagemode) {
            previewMode = previewMode + `&pageMode=${pagemode}`;
            if (guideid) {
                previewMode = previewMode + `&guideid=${guideid}`;
            }
            if (plotcode) {
                previewMode = previewMode + `&plotCode=${plotcode}`;
            }
            if (sitecode) {
                previewMode = previewMode + `&sitecode=${sitecode}`;
            }
        } else {
            if (plotcode && sitecode) {
                spCode = spCode + `&plotCode=${plotcode}&sitecode=${sitecode}`;
            }
        }
        let response = await fetch(
            `${APIPrefix.get()}/${sectionApiEndPoint}?sectionID=${sectionId}${spCode}${previewMode}`, {
            method: 'GET',
            headers: {
                'Cookie': document.cookie,
            },
        });
        if (response.status == 200) {
            let data = await response.json();
            if (data.status == "failure") {
                return data;
            } else if (data.status === "401") {
                APIUtils.redirectUserToSigninPage();
            }else {
                return data.data;
            }
        } else {
            let msg = document.querySelector('.rest-message--fail').value ? document.querySelector('.rest-message--fail').value : "";
            showErrorMessageGuides(msg);
            return false;
        }
    };

    let accordionGuides = function () {
        //ACCORDION FOR MOBILE VIEW
        let MOBILE_ACC_COMPONENTS = document.querySelectorAll('.mobile-accordion-component');
        MOBILE_ACC_COMPONENTS.forEach((accordion) => {
            const ACCORDION_LINK = accordion.getElementsByClassName('mobile-accordion-heading');
            const ACCORDION_CONTENT = accordion.querySelectorAll('.mobile-accordion-content');
            let singleMode = true;
            ACCORDION_CONTENT.forEach((accContent) => {
                const SET_DATA_HEIGHT = () => {
                    accContent.setAttribute('data-height', realHeight + 'px');
                    accContent.style.height = 0;
                };
                let realHeight = accContent.scrollHeight;
                SET_DATA_HEIGHT();
            });
            for (let i = 0; i < ACCORDION_LINK.length; i++) {
                ACCORDION_LINK[i].onclick = function(singleMode) {
                    let openedAcc = this.getAttribute('href').replace('#', '');
                    if (this.classList.contains('active')) {
                        this.classList.remove('active');
                        document.getElementById(openedAcc).style.height = 0;
                        return false;
                    }
                    if (singleMode) {
                        for (let k = 0; k < ACCORDION_LINK.length; k++) {
                            ACCORDION_LINK[k].classList.remove('active');
                        }
                        for (let j = 0; j < ACCORDION_CONTENT.length; j++) {
                            ACCORDION_CONTENT[j].style.height = 0;
                        }
                    }
                    this.classList.add('active');
                    document.getElementById(openedAcc).style.height = 'auto';
                    document.getElementById(openedAcc).style.visibility = 'visible';
                    return false;
                };
                //Default open
                if (i === 0) {
                    let openedAcc = ACCORDION_LINK[i].getAttribute('href').replace('#', '');
                    ACCORDION_LINK[i].classList.add('active');
                    document.getElementById(openedAcc).style.height = 'auto';
                    document.getElementById(openedAcc).style.visibility = 'visible';
                }
            }
        });
    };

    //create subsection content and navigation for section by id
    let createSubsectionNavigationContent = function (sectionId) {
        try {
            getSubsections(sectionId).then((subsectionsRSP) => {
                if (subsectionsRSP.status == "failure") {
                    showErrorMessageGuides(subsectionsRSP.message);
                } else {
                    if (document.querySelector('.mobile-menu')) {
                        let mobileMenu = document.querySelector('.mobile-menu');
                        mobileMenu.parentNode.removeChild(mobileMenu);
                    }
                    const SUBSECTION_TITLE = document.querySelector('[data-id="detailsAbout"]').value;
                    if (guideNavigationSubSection.querySelector('ul')) {
                        guideNavigationSubSection.querySelector('ul').innerHTML = '';
                    }
                    if (subsectionsRSP !== undefined) {
                        guideContent.innerHTML = `${subsectionsRSP.text}`;
                        let subsections = subsectionsRSP.subSections ? subsectionsRSP.subSections : [];
                        if (subsections.length > 0) {
                            guideNavigationSubSection.innerHTML = `<h4>${SUBSECTION_TITLE}</h4><ul></ul>`;
                            let existingElement = document.querySelector(".desktop-hidden");
                            if (existingElement) {
                                existingElement.remove();
                            }
                            //mobile part
                            const SUBSECTION_CONTAINER = document.createElement('div');
                            SUBSECTION_CONTAINER.setAttribute("class", "custom--forms mobile-menu");
                            let SUBSECTION_TITLE_EL = document.createElement("h4");
                            SUBSECTION_TITLE_EL.innerHTML = SUBSECTION_TITLE;
                            SUBSECTION_CONTAINER.appendChild(SUBSECTION_TITLE_EL);
                            const SUBSECTION_SELECT = document.createElement('select');
                            SUBSECTION_SELECT.setAttribute("id", "navigationSubsectionList");
                            if (subsections.length > 0) {
                                subsections.forEach(function (subsection, index) {
                                    SUBSECTION_SELECT.options[index] = new Option(subsection.title, subsection.id);
                                    if (query_subSectionId) {
                                        if (query_subSectionId == subsection.id) {
                                            SUBSECTION_SELECT.options[index].setAttribute("selected", "selected");
                                        }
                                    }
                                });
                                SUBSECTION_SELECT.onchange = function () {
                                    let subsectionId = query_subSectionId ? query_subSectionId : this.value;
                                    let active_subSections = guideNavigationSubSection.querySelectorAll(".active");
                                    active_subSections.forEach(function (activeSubsection) {
                                        activeSubsection.classList.remove("active");
                                    });
                                    let new_active_subSection = guideNavigationSubSection.querySelectorAll("a[data-subsectionid='" + this.value + "']");
                                    let parent_li = new_active_subSection[0].closest("li");
                                    parent_li.className = 'active';
                                    getContent(subsectionId, sectionId).then((contentHtml) => {
                                        if (contentHtml.status == "failure") {
                                            showErrorMessageGuides(contentHtml.message);
                                        } else {
                                            if (contentHtml) {
                                                guideContent.innerHTML = `${contentHtml}`;
                                                accordionGuides();
                                            }
                                        }
                                    });
                                };
                            }
                            let selectContainerWithArrow = document.createElement("div");
                            selectContainerWithArrow.setAttribute("class", "form--select");
                            let arrowIcon = document.createElement("i");
                            arrowIcon.setAttribute("class", "form-carett form-carett--down");
                            selectContainerWithArrow.appendChild(SUBSECTION_SELECT);
                            selectContainerWithArrow.appendChild(arrowIcon);
                            SUBSECTION_CONTAINER.appendChild(selectContainerWithArrow);
                            guideContent.parentNode.insertBefore(SUBSECTION_CONTAINER, guideContent);
                            accordionGuides();
                            //desktop part

                            if (subsections.length > 0) {
                                subsections.forEach(function (subsection, index) {
                                    const SUBSECTION_LI = document.createElement('li');
                                    const SUBSECTION_A = document.createElement('a');
                                    SUBSECTION_A.setAttribute('data-subsectionid', subsection.id);
                                    SUBSECTION_A.setAttribute('title', subsection.title);
                                    SUBSECTION_A.setAttribute('tabindex', "0");
                                    SUBSECTION_A.textContent = subsection.title;
                                    if (query_subSectionId) {
                                        if (query_subSectionId == subsection.id) {
                                            SUBSECTION_LI.className = 'active';
                                        }
                                    } else {
                                        if (index === 0) {
                                            SUBSECTION_LI.className = 'active';
                                        }
                                    }
                                    SUBSECTION_A.addEventListener('click', () => {
                                        let active_subSections = guideNavigationSubSection.querySelectorAll(".active");
                                        active_subSections.forEach(function (activeSubsection) {
                                            activeSubsection.classList.remove("active");
                                        });
                                        let parent_li = SUBSECTION_A.closest("li");
                                        parent_li.className = 'active';
                                        let subsectionId = query_subSectionId ? query_subSectionId : SUBSECTION_A.dataset.subsectionid;
                                        let subsectionSelectElement = document.getElementById('navigationSubsectionList');
                                        subsectionSelectElement.value = subsectionId;
                                        getContent(subsectionId, sectionId).then((contentHtml) => {
                                            if (contentHtml.status == "failure") {
                                                showErrorMessageGuides(contentHtml.message);
                                            } else {
                                                if (contentHtml) {
                                                    guideContent.innerHTML = `${contentHtml}`;
                                                    accordionGuides();
                                                }
                                            }
                                        });
                                    });
                                    SUBSECTION_A.addEventListener('keypress', function (event) {
                                        if (event.key === 'Enter') {
                                            let active_subSections = guideNavigationSubSection.querySelectorAll(".active");
                                            active_subSections.forEach(function (activeSubsection) {
                                                activeSubsection.classList.remove("active");
                                            });
                                            let parent_li = SUBSECTION_A.closest("li");
                                            parent_li.className = 'active';
                                            let subsectionId = query_subSectionId ? query_subSectionId : SUBSECTION_A.dataset.subsectionid;
                                            let subsectionSelectElement = document.getElementById('navigationSubsectionList');
                                            subsectionSelectElement.value = subsectionId;
                                            getContent(subsectionId, sectionId).then((contentHtml) => {
                                                if (contentHtml.status == "failure") {
                                                    showErrorMessageGuides(contentHtml.message);
                                                } else {
                                                    if (contentHtml) {
                                                        guideContent.innerHTML = `${contentHtml}`;
                                                        accordionGuides();
                                                    }
                                                }
                                            });
                                        }
                                    });
                                    SUBSECTION_LI.appendChild(SUBSECTION_A);
                                    guideNavigationSubSection.querySelector('ul').appendChild(SUBSECTION_LI);
                                });
                            }
                            guideNavigationSubSection.classList.remove("hidden");
                        } else {
                            if (guideNavigationSubSection.querySelector('h4')) {
                                guideNavigationSubSection.querySelector('h4').innerHTML = '';
                            }
                        }
                    }
                }
            });
        } catch (error) {
            console.log(error);
        }
    };

    //add subsection navigation
    let SECTION_All = guideNavigationSection.querySelectorAll('a');
    if (SECTION_All.length > 0) {
        SECTION_All.forEach(function (SECTION_ACTION) {
            SECTION_ACTION.addEventListener('keypress', function (event) {
                if (event.key === 'Enter') {
                    let ACTIVE_SECTIONS = guideNavigationSection.querySelectorAll(".active");
                    ACTIVE_SECTIONS.forEach(function (activeSection) {
                        activeSection.classList.remove("active");
                    });
                    SECTION_ACTION.className = 'active';
                    let sectionId = SECTION_ACTION.dataset.sectionid;
                    createSubsectionNavigationContent(sectionId);
                }
            });
            SECTION_ACTION.addEventListener('click', () => {
                let ACTIVE_SECTIONS = guideNavigationSection.querySelectorAll(".active");
                ACTIVE_SECTIONS.forEach(function (activeSection) {
                    activeSection.classList.remove("active");
                });
                SECTION_ACTION.className = 'active';
                let sectionId = SECTION_ACTION.dataset.sectionid;
                createSubsectionNavigationContent(sectionId);
            });
        });
    }

    //add content 
    let SUBSECTION_All = guideNavigationSubSection.querySelectorAll('a');
    if (SUBSECTION_All.length > 0 && sectionId) {
        SUBSECTION_All.forEach(function (SUBSECTION_ACTION) {
            SUBSECTION_ACTION.addEventListener('click', () => {
                let ACTIVE_SUBSECTIONS = guideNavigationSubSection.querySelectorAll(".active");
                ACTIVE_SUBSECTIONS.forEach(function (activeSubsection) {
                    activeSubsection.classList.remove("active");
                });
                let PARENT_LI = SUBSECTION_ACTION.closest("li");
                PARENT_LI.className = 'active';
                li.className = 'active';
                let subsectionId = SUBSECTION_ACTION.dataset.subsectionid;
                getContent(subsectionId, sectionId).then((contentHtml) => {
                    if (contentHtml.status == "failure") {
                        showErrorMessageGuides(contentHtml.message);
                    } else {
                        if (contentHtml) {
                            guideContent.innerHTML = `${contentHtml}`;
                            accordionGuides();
                        }
                    }
                });
            });
            SUBSECTION_ACTION.addEventListener('keypress', function (event) {
                if (event.key === 'Enter') {
                    let ACTIVE_SUBSECTIONS = guideNavigationSubSection.querySelectorAll(".active");
                    ACTIVE_SUBSECTIONS.forEach(function (activeSubsection) {
                        activeSubsection.classList.remove("active");
                    });
                    let PARENT_LI = SUBSECTION_ACTION.closest("li");
                    PARENT_LI.className = 'active';
                    li.className = 'active';
                    let subsectionId = SUBSECTION_ACTION.dataset.subsectionid;
                    getContent(subsectionId, sectionId).then((contentHtml) => {
                        if (contentHtml.status == "failure") {
                            showErrorMessageGuides(contentHtml.message);
                        } else {
                            if (contentHtml) {
                                guideContent.innerHTML = `${contentHtml}`;
                                accordionGuides();
                            }
                        }
                    });
                }
            });
        });
    }

    // your page initialization 
    window.addEventListener('load', () => {
        if ((typeof plotcode !== 'undefined' && plotcode !== null && typeof sitecode !== 'undefined' && sitecode !== null) || pagemode) {
            let firstSectionId = guideNavigationSection.querySelectorAll(".active").length > 0 ? guideNavigationSection.querySelectorAll(".active")[0].dataset.sectionid : 0;
            let currentSectionId = sectionId ? sectionId : firstSectionId;
            const guideSections = guideNavigationSection.querySelectorAll("a");
            guideSections.forEach(sectionsEl => {
                sectionsEl.setAttribute('tabindex', "0");
            });
            createSubsectionNavigationContent(currentSectionId);
        }
    });
}